import { UserDropdown } from '@ksyos/design-system';
import { ManagerAuthorization } from '@common/enums';
import { getSelectedLanguage } from '@frontend/translate';
import { hasOneAuthorization } from '@frontend/utils';
import type { UserEmployment } from '../types/userEmployment';

export type EmploymentItemsProps = {
    employment: UserEmployment;
    isSelected: boolean;
    organizationId: string;
};
export function EmploymentItems({ organizationId, isSelected, employment }: Readonly<EmploymentItemsProps>) {
    const translate = getSelectedLanguage();

    return (
        <>
            <UserDropdown.Label data-dd-action-name="nav-dropdown-select-organization-title">
                {employment.organization.name}
            </UserDropdown.Label>
            {isSelected && (
                <>
                    {(!employment.organization.isKsyos || hasOneAuthorization(ManagerAuthorization.adminsRead)) && (
                        <UserDropdown.Item
                            icon="organization"
                            style={{ marginTop: '8px' }}
                            to={`/organizations/${organizationId}/view`}
                            variant="link"
                        >
                            {translate.organization.organization}
                        </UserDropdown.Item>
                    )}
                    {!employment.organization.isKsyos && (
                        <UserDropdown.Item
                            icon="settings"
                            to={`/employments/${employment.id}/personalSettings`}
                            variant="link"
                        >
                            {translate.common.personalSettings}
                        </UserDropdown.Item>
                    )}
                </>
            )}
        </>
    );
}
